import React, { Fragment, useContext, useState } from 'react'
import { AiFillHome } from "@react-icons/all-files/ai/AiFillHome";
import { BsCalendar } from "@react-icons/all-files/bs/BsCalendar";


import { MdFamilyRestroom, MdTipsAndUpdates, MdKeyboardArrowRight, MdOutlineKeyboardArrowRight, MdFullscreen } from 'react-icons/md';
import { IoDocumentTextOutline, IoIosDocument, IoMdArrowDropdown, IoMdBook } from 'react-icons/io';
import { FaPlus } from 'react-icons/fa';
import { AiOutlineQuestionCircle, AiFillFolder, AiFillFile, AiOutlineCloseCircle, AiOutlineSearch } from 'react-icons/ai'
import { SiHandshake } from 'react-icons/si'
import { BiEdit } from 'react-icons/bi'
import Renderif from '../../components/renderif';
import SideMenu, { AdminSideMenu } from '../../components/sidemenu';

import CheckBox from '../../components/checkbox';
import DropDown, { DropDownOption } from '../../components/dropdown';
import BVCalendar from '../../components/calendar';
import { gray30, primary } from '../../utils/colors';
import Slider from '../../components/slider';
// import AgendarCitaFamiliar from './agendar_familia_client';
import { Await, useNavigate } from 'react-router-dom';
import { Service } from '../../services/api';
import { AlertContext } from '../../context/alert_context';
import { GoStarFill } from "react-icons/go";
import { GoStar } from "react-icons/go";
import { BsArrowRightSquareFill } from "react-icons/bs";
import { FiShoppingBag, FiSettings } from 'react-icons/fi';
import { IoStatsChart } from 'react-icons/io5';
import { AuthContext } from '../../context/auth_context';
import EspecialistaCard from './especialista_card';






export default function HomeAdmin() {

    const { notify } = useContext(AlertContext)
    const { user } = useContext(AuthContext)
    const [state, setState] = useState({
        show_especialist_card: false
    })
    const navigate = useNavigate();

    useState(() => {
        const init = async () => {

        };
        init();
        return () => { }
    }, [])


    const y = [0, 30, 60, 90, 120, 150]
    const x = [
        {
            date: '1 Ago',
            value: 0
        },
        {
            date: '1 Ago',
            value: 0
        },
        {
            date: '1 Ago',
            value: 0
        },
        {
            date: '1 Ago',
            value: 0
        },
        {
            date: '1 Ago',
            value: 0
        }
    ]

    return (
        <>
            <Renderif isTrue={state.show_especialist_card}>
                <EspecialistaCard onClose={() => {

                    setState({ ...state, show_especialist_card: false })

                }}></EspecialistaCard>
            </Renderif>


            <div className='container-fluid h-100 d-flex'>


                {/* <SideMenu></SideMenu> */}
                <AdminSideMenu></AdminSideMenu>

                <div className='col hide-scroll'>

                    <div className='container-fluid bg-light'>
                        <div className='container'>
                            <div className='row'>
                                <div className='d-flex  p-3'>


                                    <div className='d-flex align-items-center'>
                                        <div className='avatar avatar--mid'></div>
                                        <div className='col ps-3'>
                                            <div className='f-18 bold '>¡Hola! {user.firstName} {user.lastName}.</div>
                                            <div className='text-gray f-14 line-0'>Medicina General</div>
                                        </div>
                                    </div>
                                    <div className='col'></div>
                                    <div className='mx-3'>
                                        <div className='input--light'>
                                            <div className='bv-icon bv-icon--mid'><AiOutlineSearch size={30}></AiOutlineSearch></div>
                                            <input className='bg-transparent' placeholder='Busca Especialista'></input>
                                        </div>
                                    </div>
                                    <div className='pe-2'>
                                        <DropDown title={''} icon={<FiSettings size={24} color={gray30}></FiSettings>}>
                                            <DropDownOption disabled>
                                                <div className='d-flex align-items-center px-2'>

                                                    <div className='text-dark f-16 bold'>Etiquetas</div>

                                                    <div className='col mx-5'></div>

                                                    <div className='cursor-pointer text-decoration-underline text-primary bold f-14 prevent-select' onClick={() => {navigate('/administrador/tags')}}>Ver Etiquetas</div>

                                                </div>
                                            </DropDownOption>
                                        </DropDown>
                                    </div>
                                    <div className='bv-cta bv-cta--primary' onClick={() => {
                                        // setState({...state, show_agendar_cita:true})
                                        navigate('/administrador/calendario')
                                    }}>
                                        Ver Agenda

                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='container mt-4'>

                        <div className='row'>

                            <div className='col-8'>
                                <div className='bg-light r-10 m-2 p-3'>

                                    <div className='d-flex '>
                                        <div className='f-18 text-dark bold'>Citas Agendadas</div>
                                        <div className='col'></div>
                                        <div className=''>
                                            <div className='bv-tab bv-tab--primary bv-tab--active'>
                                                Mes
                                            </div>
                                            <div className='bv-tab'>
                                                Semana
                                            </div>
                                            <div className='bv-tab'>
                                                Dia
                                            </div>

                                        </div>
                                    </div>

                                    <div className='d-flex  pt-5'>

                                        <div className='d-flex flex-column '>
                                            {
                                                y.reverse().map((item, i) => {
                                                    return (
                                                        <div key={i} className='yh'>{item}</div>
                                                    )
                                                })
                                            }

                                        </div>

                                        <div className='col d-flex position-relative'>

                                            {
                                                x.map((item, i) => {
                                                    return (
                                                        <div key={i} className='ydivider' style={{ top: i * 90 }}></div>
                                                    )
                                                })
                                            }


                                            {
                                                x.map((item, i) => {
                                                    return (
                                                        <div key={i} className='col d-flex justify-content-center align-items-end  overflow-hidden'>
                                                            <div className='xbar' style={{ height: (item.value * 360) / 150 }}></div>
                                                        </div>
                                                    )
                                                })
                                            }










                                        </div>

                                    </div>

                                    <div className='d-flex  '>

                                        <div className='d-flex flex-column '>

                                            <div className='yh'></div>
                                        </div>
                                        <div className='col d-flex  '>

                                            {
                                                x.map((item, i) => {
                                                    return (
                                                        <div key={i} className='xh'>{item.date}</div>
                                                    )
                                                })
                                            }
                                        </div>

                                    </div>





                                </div>




                                <div className='d-flex flex-column shadow r-10 m-2 p-3 mt-4  '>

                                    <div className='d-flex'>
                                        <div>
                                            <div className='f-18 text-dark bold'>Profesionales</div>
                                            <div className='f-14 text-gray bold'>Miembros del Equipo <span className='text-blue text-decoration-underline cursor-pointer' onClick={() => {
                                                navigate('/administrador/valoraciones')
                                            }}>Ver comentarios</span></div>

                                        </div>
                                        <div className='col'></div>
                                        <div className=''>
                                            <div className='bv-tab bv-tab--primary bv-tab--active'>
                                                Mes
                                            </div>
                                            <div className='bv-tab'>
                                                Semana
                                            </div>
                                            <div className='bv-tab'>
                                                Dia
                                            </div>

                                        </div>

                                    </div>

                                    <div className='mt-4'>
                                        {
                                            [1, 1, 1].map((item, i) => {
                                                return (
                                                    <div key={i} className='d-flex align-items-center my-2'>


                                                        <div className='avatar avatar--mid me-3'></div>
                                                        <div className='col'>
                                                            <div className='text-gray f-14 bold'>Nombre Apellido</div>
                                                            <div className='text-gray f-14 line-0'>Coach Especialista</div>
                                                        </div>


                                                        <div className='col'>
                                                            <div className='text-gray f-14 bold'>Valoraciónn</div>
                                                            <div className=''>
                                                                <Rating></Rating>
                                                            </div>
                                                        </div>
                                                        <div className='col'>
                                                            <div className='text-gray f-14 bold'>Sesión Total</div>
                                                            <div className='text-gray f-14 bold'>5</div>
                                                        </div>
                                                        <div className='col'>
                                                            <div className='text-gray f-14 bold'>Retención</div>
                                                            <div className='text-gray f-14 bold'>2</div>
                                                        </div>
                                                        <div className=''>
                                                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                                                setState({ ...state, show_especialist_card: true })
                                                            }}>
                                                                <BsArrowRightSquareFill color='#00B9E1' size={30}></BsArrowRightSquareFill>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>


                                </div>
                            </div>

                            <div className='col-4'>

                                <div className='shadow r-10 m-2 py-5 '>

                                    <div className='d-flex justify-content-center'>
                                        <div className='bv-sumary'>
                                            <div className='f-24 bold'>$0</div>
                                        </div>
                                    </div>

                                    <div className='d-flex mt-5 ps-5'>
                                        <div className='col ps-5'>

                                            <div className='d-flex align-items-center'>

                                                <div className='bv-icon bv-icon--big bg-lightblue r-5 me-3'>
                                                    <FiShoppingBag size={30} color='#3699FF'></FiShoppingBag>
                                                </div>

                                                <div>
                                                    <div className='text-dark f-16 bold'>$320</div>
                                                    <div className='text-gray f-14 line-0'>Plan Basico</div>
                                                </div>

                                            </div>
                                        </div>

                                        <div className='col'>
                                            <div className='d-flex align-items-center'>

                                                <div className='bv-icon bv-icon--big bg-lightred r-5 me-3'>
                                                    <IoStatsChart size={30} color='#F64E60'></IoStatsChart>
                                                </div>

                                                <div>
                                                    <div className='text-dark f-16 bold'>$1,432</div>
                                                    <div className='text-gray f-14 line-0'>Plan Premium</div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div className='d-flex mt-4 ps-5'>

                                        <div className='col ps-5'>

                                            <div className='d-flex align-items-center'>

                                                <div className='bv-icon bv-icon--big bg-lightgreen r-5 me-3'>
                                                    <IoMdBook size={30} color='#0BB783'></IoMdBook>
                                                </div>

                                                <div>
                                                    <div className='text-dark f-16 bold'>$582</div>
                                                    <div className='text-gray f-14 line-0'>Sesion Extra</div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className='col'>
                                            <div className='d-flex align-items-center'>

                                                <div className='bv-icon bv-icon--big bg-lightpurple r-5 me-3'>
                                                    <MdFullscreen size={30} color='#8950FC'></MdFullscreen>
                                                </div>

                                                <div>
                                                    <div className='text-dark f-16 bold'>$32,230</div>
                                                    <div className='text-gray f-14 line-0'>Plan Gratuito</div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>







                    </div>
                    <div className='my-5'></div>
                </div>
            </div>
        </>
    )
}



export function Rating({ value = 5 }) {

    return (
        <div className='d-flex'>
            <div className='bv-icon '>

                <Renderif isTrue={value > 0}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 1}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>

            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 1}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 2}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 2}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 3}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 3}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 4}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 4}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 5}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>
        </div>
    )
}


